module.exports = __webpack_public_path__ + "img/sec55.392b1320.jpg";